/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Grid, Paper, Typography } from "@mui/material";
import FormTitle from "../../../form-fields/form-title";
import TextInput from "../../../form-fields/text-input";
import SelectInput from "../../../form-fields/select-input";
import DashBoardContainer from "../../../layout/dashboard-container";
import {
  FormLabel,
  FormValue,
  GridRow,
} from "../generate-receipt/custom-form-grid";
import { useSelector } from "react-redux";
import { useFormik, FormikProvider, Form } from "formik";
import { useNavigate } from "react-router-dom";
import FormButtons from "../buttons";
import useApiState from "../../common/useApiState";
import Loader from "../../../loader/loader";
import AlertMsg from "../../../common/alert";

const EdcReceipt = () => {
  const navigate = useNavigate();
  const initialState = {
    transactionAmount: "",
    plutusTrnRefId: "",
    action: "",
    reason: "",
  };
  const { loading, setLoading, error, setError, success, setSuccess } =
    useApiState();

  const lang = useSelector((state) => state.userDetails.lang);
  const formik = useFormik({
    initialValues: initialState,
    // validationSchema: ,
  });

  const handleSubmitButtonClick = async (e) => {
    e.preventDefault();
  };

  return (
    <DashBoardContainer>
      {loading && <Loader />}
      {error && (
        <AlertMsg
          severity="error"
          onClose={() => {
            setError("");
          }}
        />
      )}
      <FormikProvider value={formik}>
        <Form>
          <Paper elevation={4} sx={{ marginBottom: "15px" }}>
            <FormTitle title="EDC Transaction" />
            <Grid>
              <Grid display="flex" justifyContent="center">
                <FormLabel label="Plutus Trn Ref ID:" />
                <FormValue
                  component={
                    <Typography variant="subtitle2">12412421</Typography>
                  }
                />
              </Grid>
              <Grid display="flex" justifyContent="center">
                <FormLabel label="Transaction Amount:" />
                <FormValue
                  component={
                    <Typography variant="subtitle2">12412421</Typography>
                  }
                />
              </Grid>
              <Grid display="flex" justifyContent="center">
                <FormLabel label="Action" />
                <FormValue
                  component={
                    <SelectInput
                      name="action"
                      options={[{ label: "test", value: "test" }]}
                    />
                  }
                />
              </Grid>
              <Grid display="flex" justifyContent="center">
                <FormLabel label="Reason" />
                <FormValue
                  component={
                    <SelectInput
                      name="reason"
                      options={[{ label: "test", value: "test" }]}
                    />
                  }
                />
              </Grid>
              <Grid container justifyContent="center" alignItems="center">
                <Grid
                  item
                  md={3}
                  container
                  justifyContent={{ md: "flex-end" }}
                  alignItems="center"
                  p={2}
                >
                  <FormButtons
                    isValid={!(formik.isValid && formik.dirty)}
                    handleSubmitButtonClick={handleSubmitButtonClick}
                    resetForm={() => {
                      formik.resetForm();
                      setError("");
                    }}
                    submitBtnLabel="Submit"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Form>
      </FormikProvider>
    </DashBoardContainer>
  );
};
export default EdcReceipt;
